import React from 'react'
import { OverviewItems } from 'components/cases/common/Overview/Overview'
import { IssueSolutionItems } from 'components/cases/common/OverviewHeight/OverviewHeight'
import { CaseStudyItems } from 'components/cases/common/CaseStudy/CaseStudy'
import { CaseCTAItem } from 'components/cases/common/CaseCTA'
import { CaseDownloadCTAItem } from 'components/cases/common/CaseDownloadCTA'
import styles from 'components/cases/common/Overview/Overview.module.scss'

// ファーストビュー
export const firstViewItemWhite = {
  breadcrumb: '海外送金アプリを刷新し、ロイヤルティ向上と改修工数削減を実現',
  title1: <>海外送金アプリを刷新し、ロイヤルティ向上と改修工数削減を実現</>,
  company: 'SBIレミット株式会社',
  introduction_text: (
    <>
      「SBI Remit
      アプリ」は、業界最低水準の手数料で、200以上の国と地域への簡単・便利な海外送金を実現するSBIレミット株式会社が提供するアプリです。
      <br />
      モバイルシフトが進む現代において、送金手続きの安全性や手数料の安さなどはもちろんのこと、「アプリの使いやすさ」は、ユーザー獲得と顧客ロイヤルティに大きく影響することがあります。
      Aitriaは、本アプリのUX/UIデザインから開発までを一気通貫で支援しました。
    </>
  ),
  tag1text: 'アプリケーション開発',
  tag1src: '/cases/application-development/',
  tag2text: 'フロントエンド開発',
  tag2src: '/cases/frontend-dev/',
  tag3text: 'UX/UI改善',
  tag3src: '/cases/uxui-improvement/',
  industryTagText: '金融/不動産',
  industryTagSrc: '/cases/finance/',
  image: '/images/img/cases/remit/mv.webp',
  movie: '',
  alt: '海外送金アプリを刷新し、ロイヤルティ向上と改修工数削減を実現',
}

// プロジェクト概要
export const overviewTitle = 'UX/UI刷新で国際送金をより快適に'

export const overviewItem: OverviewItems[] = [
  {
    text: (
      <>
        フィンテックやブロックチェーンといった技術革新と規制緩和により、銀行を介さない低コストかつ迅速な送金環境の整備が進んでいます。
        <br />
        そして個人向け海外送金事業は、EY Globalによると2032年までに市場規模が4.7兆米ドルに達すると予測されています。
      </>
    ),
  },
  {
    text: (
      <>
        市場拡大が進む一方で、各社が手数料の引き下げを進めた結果、送金手数料や為替手数料での差別化は限界を迎えつつあります。
        <br />
        機能や価格で差がつきづらい中、
        <span className={styles.textbold}>競合優位性の鍵となるのは「顧客体験（UX）」</span>
        でした。
      </>
    ),
  },
  {
    text: (
      <>
        そこで、<span className={styles.textbold}>UX/UIの改善による顧客ロイヤルティの向上</span>と、
        <span className={styles.textbold}>継続改善のためのハイブリッドアプリ化による改修工数の削減</span>
        を、SBIレミット社とAitriaが共同で実現しました。
      </>
    ),
  },
  {
    image: [
      {
        src: '/images/img/cases/remit/approach01.webp',
        alt: '現状課題の可視化と「安心できる世界観」の構築',
      },
    ],
  },
]

// 課題と解決策
export const issueSolutionItems: IssueSolutionItems[] = [
  {
    issues: [
      {
        title: 'ユーザビリティ課題による膨らんだ問い合わせコストと市場競争力低下',
        text: 'アプリの利便性低下により問い合わせが増えて社内工数が逼迫し、かつ操作性の面でも競合サービスと比較して改善の余地があり、結果的にユーザー離れを招いていた。',
      },
      {
        title: '複雑な開発環境による機能改善の工数増大',
        text: 'ウェブとアプリで開発環境が異なっていたため、新機能を実装する際の影響調査に時間がかかっていた。加えて改修が必要な箇所が広範囲に及び、対応コストが膨らんでいた。',
      },
      {
        title: '不正利用を防ぐためのセキュリティ強化の必要性',
        text: '不正送金被害の増加により、金融系デジタルプロダクトにはさらなるセキュリティ対策の強化が求められている。',
      },
    ],
    solutions: [
      {
        title: '抜本的なUX/UIデザインの刷新',
        text: 'エキスパートレビューとユーザビリティテストを実施し、ターゲットユーザーのメンタルモデルに即したUX/UIデザインでユーザビリティを改善。',
      },
      {
        title: 'スピーディな継続開発を実現する基盤の構築',
        text: 'クロスプラットフォーム開発やハイブリッドアプリ化により、開発スピード・コスト・品質のバランスを最適化し、継続的な改善を実現するための土台作り。',
      },
      {
        title: '堅牢性と安定稼働の両立',
        text: 'ログイン時の認証強化とクラウドサービスの活用で、セキュリティやアクセスの面でユーザーが安心してアプリを利用できる環境を整備。',
      },
    ],
    outcomes: [
      {
        title: '「迷わない体験」の実現',
        text: '1画面ごとに丁寧かつロジカルな検討を重ね、直感的に理解しやすい構造と操作性を追求。見た目の美しさと使いやすさを両立したアプリを完成させました。',
      },
      {
        title: 'ユーザーの安心感・信頼感の向上',
        text: 'キャラクターの設置やUIの丸み、色のトーンといった細部にこだわることで、「信頼・安全・落ち着き」という価値をユーザー体験として体現しました。',
      },
      {
        title: '社内外からの高い評価',
        text: 'リリース後に「旧アプリより見やすい」「使いやすい」という社内の声が上がり、お客様への提案にも自信を持って臨めるようになるなど、サービス全体の信頼向上につながりました。',
      },
    ],
  },
]

// CTA
export const caseCTAItem: CaseCTAItem = {
  title: 'UX刷新でロイヤルティ向上を実現しませんか？',
  description: (
    <>
      アプリの市場競争力の向上と改修工数の削減を同時に実現します。
      <br />
      まずは現在の課題やお悩みをお聞かせください。
    </>
  ),
}

// 資料ダウンロード CTA
export const caseDownloadCTAItem: CaseDownloadCTAItem = {
  title: 'アプリ開発RFP作成のポイント',
  description: 'アプリ開発担当者向けに、失敗しないためのポイントをテンプレート付の1冊にまとめました',
  imageSrc: '/images/img/cases/cta_rfp.webp',
  href: '/download/rfp/',
}

// 関連事例
export const caseStudyItem: CaseStudyItems = [
  {
    projectName: '【技術系災害ボランティア体験】家屋再生〜水害編〜',
    client: '公益財団法人日本財団ボランティアセンター様',
    src: '/images/img/case/img_case_volunteer-ex.png',
    alt: '公益財団法人日本財団ボランティアセンター様',
    href: '#',
    tags: [{ name: 'XR/メタバース導入', url: 'xr' }],
  },
  {
    projectName: 'PEACH JOHN',
    client: '株式会社ピーチ・ジョン様',
    src: '/images/img/case/img_peachjohn.png',
    alt: '株式会社ピーチ・ジョン様',
    href: '#',
    tags: [
      { name: 'UX/UIデザイン', url: 'uiux' },
      { name: 'アプリケーション開発', url: 'application-development' },
      { name: '小売', url: 'service' },
    ],
  },
  {
    projectName: 'セブンネットショッピング「推し活倶楽部」',
    client: '株式会社セブンネットショッピング様',
    src: '/images/img/case/img_sevennet.png',
    alt: '株式会社セブンネットショッピング様',
    href: '#',
    tags: [
      { name: 'UX/UIデザイン', url: 'uiux' },
      { name: 'アーキテクチャ設計サービス', url: 'architecture-design' },
      { name: '小売', url: 'service' },
    ],
  },
]
